import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Card, Statistic } from "antd";
import CountUp from "react-countup";
import moneyFormat from "functions/utils/moneyFormat";
import { bg_button } from "constant/css";
import GetSbIncome from "functions/admin/getSbIncome";

const mainColor = "#46ce7c";
const secondaryColor = "#2a8e57";
const qpayColor = "#8adecd";
const cardColor = "#78c2b7";

const SbIncomeGraph = () => {
  const [data, setData] = useState([]);
  const [totalMonth, setTotalMonth] = useState(0);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const response = await GetSbIncome();
    if (!response || response.data.length === 0) return;

    setTotalMonth(
      response.data.reduce((acc, item) => acc + parseFloat(item.total), 0)
    );
    const data = response.data.map((item) => {
      return {
        Oрлого: item.total,
        name: item.date,
      };
    });
    setData(data);
  };

  const CustomLegend = ({ payload }) => (
    <div className="flex justify-center gap-6 mt-4">
      {payload.map((entry, idx) => {
        const color = cardColor;
        const icon = (
          <img
            src="/smartbillingbg.png"
            width={22}
            height={22}
            className="rounded-md shadow-md"
            style={{ boxShadow: `0 2px 8px ${qpayColor}40` }}
          />
        );

        return (
          <div
            key={idx}
            className="flex items-center gap-2 font-semibold tracking-wide"
            style={{ color }}
          >
            {icon}
            <span>{entry.value.toUpperCase()}</span>
          </div>
        );
      })}
    </div>
  );

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-md">
          <div className="font-semibold mb-2">{label}</div>
          {payload.map((item, idx) => (
            <div
              key={idx}
              className="font-medium"
              style={{ color: item.color }}
            >
              {item.name}:{" "}
              <CountUp
                end={item.value}
                separator=","
                decimals={2}
                decimal="."
              />
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  const formatter = (value) => <CountUp end={value} separator="," />;
  const moneyFormatter = (value) => (
    <CountUp end={value} separator="," decimals={2} decimal="." />
  );

  return (
    <Card
      className="w-full mt-6 rounded-2xl shadow-lg border-0"
      bodyStyle={{ padding: 0 }}
    >
      {/* Header */}
      <div className={`p-8 rounded-t-2xl ${bg_button}`}>
        <div className="flex justify-between items-center mb-4">
          <div>
            <div className="text-2xl font-bold text-gray-100 tracking-wide">
              Орлого сараар
            </div>
            <div className="text-gray-200 text-sm mt-1">Орлого сараар</div>
          </div>
          <div className="flex gap-8 text-gray-100">
            <Statistic
              title="Дүн"
              value={totalMonth}
              formatter={moneyFormatter}
              valueStyle={{ fontWeight: 700, color: secondaryColor }}
            />
          </div>
        </div>
      </div>

      {/* Chart Body */}
      <div
        className={`p-8 pt-0 rounded-b-2xl bg-gradient-to-b from-[#fff] via-[#d1e6e8] to-[#d1ebe5]`}
      >
        <ResponsiveContainer width="100%" height={380}>
          <BarChart
            data={data}
            margin={{ top: 30, right: 30, left: 10, bottom: 10 }}
            barCategoryGap={24}
          >
            <defs>
              <linearGradient id="qpayGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={qpayColor} stopOpacity={0.9} />
                <stop offset="100%" stopColor="#c8e3de" stopOpacity={0.7} />
              </linearGradient>
            </defs>
            <CartesianGrid
              strokeDasharray="3 3"
              vertical={false}
              stroke="#c4f0d9"
            />
            <XAxis
              dataKey="name"
              axisLine={{ stroke: "#97d1c4" }}
              tickLine={false}
              tick={{ fill: "#438c7c", fontSize: 15, fontWeight: 600 }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: cardColor, fontSize: 14, fontWeight: 600 }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend content={<CustomLegend />} />
            <Bar
              dataKey="Oрлого"
              radius={[12, 12, 0, 0]}
              fill="url(#qpayGradient)"
              barSize={28}
            >
              <LabelList
                dataKey="Oрлого"
                position="top"
                formatter={(v) => (v > 0 ? moneyFormat(parseFloat(v)) : "")}
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default SbIncomeGraph;
